module.exports = __webpack_public_path__ + "static/media/about-anchors.16b7989f.jpg";